
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M352.46 220c0-11.046-8.954-20-20-20h-206c-11.046 0-20 8.954-20 20s8.954 20 20 20h206c11.046 0 20-8.954 20-20zm-226 60c-11.046 0-20 8.954-20 20s8.954 20 20 20h125.1c11.046 0 20-8.954 20-20s-8.954-20-20-20h-125.1zm47 192h-66.9c-22.056 0-40-17.944-40-40V80c0-22.056 17.944-40 40-40h245.9c22.056 0 40 17.944 40 40v123c0 11.046 8.954 20 20 20s20-8.954 20-20V80c0-44.112-35.888-80-80-80h-245.9c-44.112 0-80 35.888-80 80v352c0 44.112 35.888 80 80 80h66.9c11.046 0 20-8.954 20-20s-8.954-20-20-20zm294.424-182.428c-23.394-23.394-61.458-23.395-84.837-.016l-109.803 109.56a19.88 19.88 0 00-5 8.345l-23.913 78.725A20 20 0 00263.459 512a19.97 19.97 0 005.338-.727l80.725-22.36a20.075 20.075 0 008.8-5.12l109.573-109.367c23.394-23.394 23.394-61.458-.001-84.854zM333.776 451.768l-40.612 11.25 11.885-39.13 74.1-73.925 28.3 28.3-73.652 73.514zm105.84-105.638l-3.875 3.867-28.285-28.285 3.862-3.854c7.798-7.798 20.486-7.798 28.284 0s7.798 20.486.014 28.272zM332.46 120h-206c-11.046 0-20 8.954-20 20s8.954 20 20 20h206c11.046 0 20-8.954 20-20s-8.954-20-20-20z"}})])
          )
        }
      }
    